export default {
    application: {
        Production: true,
        PreProduction: true,
        UAT: true,
        SVT: true,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    attachment: {
        Production: true,
        PreProduction: true,
        UAT: true,
        SVT: true,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    labelQuestion: {
        Production: true,
        PreProduction: true,
        UAT: true,
        SVT: true,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    chartsDashboard: {
        Production: true,
        PreProduction: true,
        QA: true,
        SVT: true,
        UAT: true,
        Mock: true,
        Development: true,
        Local: true
    },
    newInfoArchitecture: {
        Production: false,
        PreProduction: false,
        QA: true,
        SVT: true,
        UAT: false,
        Mock: true,
        Development: true,
        Local: true
    },
    appSpecificPermission: {
        Production: false,
        PreProduction: false,
        QA: false,
        UAT: false,
        SVT: false,
        Mock: false,
        Development: true,
        Local: false
    },
    nguc: {
        Production: false,
        PreProduction: false,
        QA: false,
        UAT: false,
        SVT: false,
        Mock: false,
        Development: true,
        Local: true
    },
    buttonIntegrations: {
        Production: true,
        PreProduction: true,
        UAT: true,
        SVT: true,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    mdmPreBill: {
        Production: false,
        PreProduction: false,
        QA: false,
        UAT: false,
        SVT: false,
        Mock: false,
        Development: true,
        Local: true
    },
    maximListPage: {
        Production: true,
        PreProduction: true,
        QA: true,
        UAT: true,
        SVT: true,
        Mock: true,
        Development: true,
        Local: true
    },
    fnc: {
        Production: false,
        PreProduction: false,
        QA: true,
        UAT: false,
        SVT: false,
        Mock: false,
        Development: true,
        Local: true
    },
    nbnDiagnostics: {
        Production: false,
        PreProduction: false,
        QA: false,
        UAT: false,
        SVT: false,
        Mock: false,
        Development: false,
        Local: true
    },
    michelAngeloPriceList: {
        Production: false,
        PreProduction: false,
        UAT: false,
        QA: false,
        SVT: false,
        Development: false,
        Mock: true,
        Local: true
    },
    nbnMultipleSelection: {
        Production: false,
        PreProduction: false,
        QA: false,
        UAT: false,
        SVT: false,
        Mock: true,
        Development: false,
        Local: true
    },
    serviceTool: {
        Production: false,
        PreProduction: false,
        QA: true,
        UAT: false,
        SVT: false,
        Mock: true,
        Development: true,
        Local: true
    },
    nbnSearch: {
        Production: false,
        PreProduction: false,
        QA: false,
        UAT: false,
        SVT: false,
        Mock: true,
        Development: false,
        Local: true
    },
    nbnHistory: {
        Production: false,
        PreProduction: false,
        QA: false,
        UAT: false,
        SVT: false,
        Mock: true,
        Development: false,
        Local: true
    },
    networkReports: {
        Production: false,
        PreProduction: false,
        QA: true,
        UAT: false,
        SVT: false,
        Mock: true,
        Development: true,
        Local: true
    },
    sdwanInt: {
        Production: false,
        PreProduction: false,
        QA: true,
        UAT: false,
        SVT: false,
        Mock: true,
        Development: true,
        Local: true
    },
    secureEdgeNetwork: {
        Production: false,
        PreProduction: false,
        QA: true,
        UAT: false,
        SVT: false,
        Mock: true,
        Development: true,
        Local: true
    },
    digiAddressLookup: {
        Production: false,
        PreProduction: false,
        QA: true,
        UAT: false,
        SVT: false,
        Mock: true,
        Development: true,
        Local: true
    },
    isServiceToolButtonVisible: {
        Production: false,
        PreProduction: false,
        QA: true,
        UAT: false,
        SVT: false,
        Mock: true,
        Development: true,
        Local: true
    },
    intNtwReptButnVisible: {
        Production: false,
        PreProduction: false,
        QA: true,
        UAT: false,
        SVT: false,
        Mock: true,
        Development: true,
        Local: true
    },
    intNtwReptButnMFA: {
        Production: true,
        PreProduction: true,
        QA: true,
        UAT: true,
        SVT: true,
        Mock: true,
        Development: true,
        Local: true
    },
    deliveryContactsTed697: {
        Production: false,
        PreProduction: false,
        QA: true,
        UAT: false,
        SVT: false,
        Mock: true,
        Development: true,
        Local: true
    },
    showProductName: {
        Production: false,
        PreProduction: false,
        QA: true,
        UAT: false,
        SVT: false,
        Mock: true,
        Development: true,
        Local: true
    },
    showPmInsightMetric: {
        Production: false,
        PreProduction: false,
        QA: true,
        UAT: false,
        SVT: false,
        Mock: true,
        Development: true,
        Local: true
    },
    tedt69615InternetProductTracking: {
        Production: false,
        PreProduction: false,
        QA: true,
        UAT: false,
        SVT: false,
        Mock: true,
        Development: true,
        Local: true
    },
    ypsLandingAble: {
        Production: {bvtEnabledFeature: false, flagState: false},
        PreProduction: {bvtEnabledFeature: false, flagState: false},
        UAT: {bvtEnabledFeature: false, flagState: false},
        SVT: {bvtEnabledFeature: false, flagState: false},
        QA: {bvtEnabledFeature: true, flagState: true},
        Mock: {bvtEnabledFeature: true, flagState: true},
        Development: {bvtEnabledFeature: true, flagState: true},
        Local: {bvtEnabledFeature: true, flagState: true}
    },
};
